export default function Cookies() {
    return (
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20 prose prose-stone">
            <h1 className="font-display text-4xl font-bold mb-6">Política de Cookies</h1>
            <p className="text-stone-500 text-sm mb-8">Última atualização: {new Date().toLocaleDateString("pt-PT")}</p>
            <p>Este website utiliza cookies para melhorar a sua experiência de navegação. Este texto é um modelo e deve ser validado antes da publicação definitiva.</p>
            <h2 className="font-display text-2xl mt-8 mb-3">O que são cookies</h2>
            <p>Os cookies são pequenos ficheiros de texto armazenados no seu dispositivo para reter informação relativa à sua utilização do website.</p>
            <h2 className="font-display text-2xl mt-8 mb-3">Cookies essenciais</h2>
            <p>Necessários ao funcionamento do website e não requerem consentimento.</p>
            <h2 className="font-display text-2xl mt-8 mb-3">Cookies analíticos e de marketing</h2>
            <p>Apenas serão utilizados após o seu consentimento. Poderá alterar as suas preferências a qualquer momento eliminando os cookies do seu navegador.</p>
        </div>
    );
}
